var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXboxOneXButton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 17,
    stroke: "#BBBBBB",
    strokeWidth: 2.24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2066 29L19.1834 19.5992L13.0311 10.9613H15.8734L19.1465 15.5879C19.8273 16.5477 20.3113 17.2859 20.5984 17.8027C21.0004 17.1465 21.4762 16.4615 22.0258 15.7479L25.6557 10.9613H28.252L21.915 19.4639L28.7441 29H25.791L21.2506 22.5646C20.9963 22.1955 20.7338 21.7936 20.4631 21.3588C20.0611 22.015 19.774 22.4662 19.6018 22.7123L15.0736 29H12.2066Z",
    fill: "#BBBBBB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXboxOneXButton);
export default __webpack_public_path__ + "static/media/XBOXOne-XButton.d9aa1f3bae0f7c1909c7b2d00803c740.svg";
export { ForwardRef as ReactComponent };